export const closeMiniCart = () => ({
    type: "CLOSE_MINI_CART",
});

export const openMiniCart = () => ({
    type: "OPEN_MINI_CART",
});
